import { actions } from "./action-list";

export function vehicleWiseCollectionFetched(value) {
  return {
    type: actions.FETCH_COLLECTION.FETCH_VEHICLE_WISE_COLLECTION,
    value,
  };
}

export function collectionSummaryFetched(value) {
  return {
    type: actions.FETCH_COLLECTION.FETCH_COLLECTION_SUMMARY,
    value,
  };
}

export function dayWiseCollectionFetched(value) {
  return {
    type: actions.FETCH_COLLECTION.FETCH_DAY_WISE_COLLECTION,
    value,
  };
}

export function grossContributionUploadSheet(value) {
  return {
    type: actions.GROSS_CONTRIBUTION_UPLOAD,
    value,
  };
}

export function grossContributionUploadSheetFailure(value) {
  return {
    type: actions.GROSS_CONTRIBUTION_UPLOAD_FAILURE,
    value,
  };
}
